import styles from "./Hero.module.css";

export function Hero() {
  return (
    <section className={styles.hero} id="top">
      <div className={styles.wash} />
      <div className={styles.rifle} aria-hidden="true">
        <img
          src="/assets/art/m1908-hero.png?v=right"
          alt=""
          width={1920}
          height={780}
        />
      </div>
      <p className={styles.stamp}>
        Index 317
        <br />
        RF · Mexico / SIG
      </p>
      <div className={styles.copy}>
        <p className={styles.kicker}>Fusil Porfirio Díaz Sistema Mondragón</p>
        <h1 className={styles.title}>MONDRAGÓN</h1>
        <p className={styles.line}>
          Mexico’s first self-loading rifle — and the elegant Griffin doll wielding it.
        </p>
        <a className={styles.cta} href="#rifle">
          Inspect the M1908
        </a>
      </div>
    </section>
  );
}
